import { NgModule } from '@angular/core';
import { DragTabsDirective } from './components/tab/drag-tabs.directive';
import { NullValueDirective } from './components/directive/null-value-directive.component';
import { DecimalOnlyDirective } from './components/directive/decimal-only-directive.component';
import { MaxLengthDirective } from './components/directive/max-length-directive.component';
import { IntegerOnlyDirective } from './components/directive/integer-only-directive.component';
import { UppercaseValueDirective } from './components/directive/uppercase-value-directive.component';

@NgModule({
  declarations: [DragTabsDirective, DecimalOnlyDirective, NullValueDirective, MaxLengthDirective, IntegerOnlyDirective, UppercaseValueDirective],
  imports: [],
  exports: [DragTabsDirective, DecimalOnlyDirective, NullValueDirective, MaxLengthDirective, IntegerOnlyDirective, UppercaseValueDirective],
})
export class SharedModule {}
